<form
  [formGroup]="form"
  (ngSubmit)="onSave()"
  class="flex flex-col">
  <div class="flex w-full justify-between mt-6 border-b border-neutral-300 py-4 sticky top-0 bg-white z-50">
    <span class="text-[18px] font-bold">
      <i
        [class.pi]="true"
        [class.pi-file-plus]="true"
        style="font-size: 2rem"></i>
      DAR DE ALTA SISTEMA DE IA
    </span>
    <div class="flex gap-4">
      <app-buttons
        [label]="'Cancelar'"
        (click)="backPage()" />
      <app-buttons
        [label]="'Guardar'"
        [disabled]="form.invalid"
        [classes]="'bg-primary-base text-primary-light'"
        type="button"
        (click)="confirm()" />
    </div>
  </div>
  <div class="flex flex-col py-4 gap-2">
    <span class="text-2xl font-bold">Datos del sistema</span>
    <label class="text-[16px] font-normal text-neutral-dark">Escribe los datos del sistema de IA</label>
    <span class="text-[16px] text-neutral-dark py-2">
      Todos los campos marcados con un asterisco (*) son obligatorios.
    </span>
  </div>
  <div class="flex flex-col gap-10">
    <div class="flex flex-col gap-6">
      <div class="text-[18px] font-bold">Datos funcionales</div>
      <div class="grid grid-cols-2 gap-3">
        <div class="flex flex-col flex-1 w-full project-search-field">
          <label>Proyecto asociado*</label>
          <div class="project-search pt-2">
            <p-autoComplete
              formControlName="projectCodes"
              [suggestions]="projectOptions"
              (completeMethod)="onSearchProjects($event)"
              (onSelect)="onProjectSelected($event)"
              placeholder="Búsqueda nombre del proyecto"
              class="w-full flex-1 block"
              optionLabel="proyecto"
              [emptyMessage]="projectSearchLoading() ? 'Buscando...' : 'No hay resultados'"
              [forceSelection]="true"
              [minLength]="3"
              [disabled]="isProjectAutofilled()">
              <ng-template
                let-item
                pTemplate="item">
                {{ item.codigo_proyecto }} - {{ item.proyecto }}
              </ng-template>
              <ng-template
                let-item
                pTemplate="selectedItem">
                {{ item.proyecto }}
              </ng-template>
            </p-autoComplete>
            <desy-spinner
              *ngIf="projectSearchLoading()"
              class="project-search__spinner"></desy-spinner>
          </div>
          <desy-error-message *ngIf="getError(form, 'projectCodes', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1">
          <span>Nombre del sistema*</span>
          <desy-input
            id="system-name"
            [classes]="'w-full'"
            formControlName="systemName"></desy-input>
          <desy-error-message *ngIf="getError(form, 'systemName', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col flex-1">
          <label class="text-[16px]">Tipo de sistemas*</label>
          <desy-select
            formControlName="systemType"
            classes="min-w-full mt-2">
            <desy-label>Selecciona un tipo de sistema</desy-label>
            <desy-option
              [disabled]="true"
              [hidden]="true"
              [selected]="true"
              value="">
              Selecciona el tipo de sistema
            </desy-option>
            <desy-option
              *ngFor="let item of typeSystem"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'systemType', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col flex-1 mt-4 gap-2">
          <span>Otro tipo de sistema*</span>
          <desy-input
            [formControl]="otherSystemTypeControl"
            placeholder="Especifica el tipo de sistema"
            [classes]="'w-full mt-2'"></desy-input>
        </div>
        <desy-error-message *ngIf="getError(form, 'otherSystemType', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>
      </div>
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-3">
          <label class="text-[16px] font-bold">Funciones o tareas a las que da soporte el sistema*</label>
          <desy-tree
            [name]="name"
            [id]="id"
            [type]="type"
            formControlName="functionOfSystem"
            [idPrefix]="idPrefix"
            [expandedFirstLevel]="true">
            <desy-tree-items-generator
              [items]="autogeneratedItems"
              [itemTemplate]="itemTemplate"></desy-tree-items-generator>

            <ng-template
              #itemTemplate
              let-item="item">
              <desy-tree-item
                [id]="idPrefix + '-' + item.id"
                [value]="item.value"
                [expanded]="item.expanded"
                [disabled]="item.disabled">
                <desy-label>{{ item.label }}</desy-label>

                <desy-tree-sub *ngIf="item.sub && item.sub.items.length">
                  <ng-container *ngFor="let subItem of item.sub.items">
                    <ng-container *ngTemplateOutlet="itemTemplate; context: { item: subItem }"></ng-container>
                  </ng-container>
                </desy-tree-sub>
              </desy-tree-item>
            </ng-template>
          </desy-tree>
          <desy-error-message *ngIf="getError(form, 'functionOfSystem', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col flex-1 gap-2">
          <div class="flex flex-1 gap-2 items-center">
            <div class="flex flex-col w-[50%] gap-2">
              <label
                class="text-[16px]"
                for="otherFunctions">
                Otras funciones o tareas
              </label>
              <desy-input
                id="otherFunctions"
                [classes]="'w-full'"
                [placeholder]="'Escribe aquí'"
                [ngModel]="otherFunction()"
                (ngModelChange)="otherFunction.set($event)"
                [ngModelOptions]="{ standalone: true }"></desy-input>
            </div>
            <div class="mt-2">
              <app-buttons
                type="button"
                (click)="addFunctions($event)"
                [label]="'Añadir'"
                [classes]="'bg-primary-base text-white'"></app-buttons>
            </div>
          </div>
          <div class="flex justify-between mb-4 -mt-8">
            <div class="flex gap-1">
              @for (item of otherFunctions(); track item) {
                <app-pill
                  [isDeletable]="true"
                  [classe]="'c-pill--primary'"
                  [value]="item"
                  (accions)="removeFunctions(item)" />
              }
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-[18px]]">Descripción del funcionamiento del sistema*</label>
          <span class="text-[16px] text-neutral-dark">
            Descripción básica y concisa de la información utilizada por el sistema (datos, entradas) y su lógica de
            funcionamiento
          </span>
          <desy-textarea
            formControlName="description"
            classes="w-full"
            class="w-full"
            [rows]="5"
            [maxlength]="500"></desy-textarea>
          <desy-error-message *ngIf="getError(form, 'description', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-[16px]">Fecha estimada de despliegue del sistema*</label>
          <app-date-picker
            [inline]="false"
            [placeholder]="'Seleccione una fecha'"
            [minDate]="minSelectableDate"
            formControlName="estimatedDeployDate" />
          <desy-error-message *ngIf="getError(form, 'estimatedDeployDate', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Datos identificativos</span>

      <div class="flex flex-col flex-1 gap-2">
        <label class="text-[16px]">Proveedor del sistema de IA*</label>
        <desy-select
          formControlName="aiSystemProviderType"
          classes="min-w-full">
          <desy-label>Seleccione proveedor de sistema</desy-label>
          <desy-option
            [disabled]="true"
            [hidden]="true"
            [selected]="true"
            value="">
            Selecciona el proveedor de sistema
          </desy-option>
          <desy-option
            *ngFor="let item of systemProviderOptions"
            [id]="item.label"
            [value]="item.value">
            {{ item.label }}
          </desy-option>
        </desy-select>
        <desy-error-message *ngIf="getError(form, 'aiSystemProviderType', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>
      </div>

      <div class="flex flex-col flex-1">
        <label class="text-[16px]">Nombre del proveedor*</label>
        <desy-textarea
          formControlName="aiProviderName"
          classes="w-full"
          class="w-full"
          [rows]="5"
          [placeholder]="'Si el proveedor es externo, especifique cuál es'"
          [maxlength]="100"></desy-textarea>
        <desy-error-message *ngIf="getError(form, 'aiProviderName', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>
      </div>
    </div>
    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Cuestiones técnicas</span>
      <div class="flex flex-col">
        <div class="flex flex-col flex-1 -mt-4">
          <label class="text-[16px]">Modelo de IA*</label>
          <desy-textarea
            formControlName="aiModelName"
            classes="w-full"
            class="w-full"
            [rows]="5"
            [placeholder]="'Nombre del modelo o familia de modelos utilizados'"
            [maxlength]="200"></desy-textarea>
          <desy-error-message *ngIf="getError(form, 'aiModelName', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xl font-bold">Datos de entrada</span>
      <label class="text-[16px]">Volumen funcional estimado de entrada*</label>
      <label class="text-[16px] text-neutral-dark">
        Estimación/volumen real del número total de unidades e información (documentos, páginas, consultas, etc.) que el
        sistema de IA procesara durante un periodo de referencia (normalmente un año)
      </label>
      <desy-input
        [type]="'number'"
        id="estimatedFunctionalInputVolume"
        [classes]="'w-1/2'"
        formControlName="estimatedFunctionalInputVolume"></desy-input>
      <desy-error-message *ngIf="getError(form, 'estimatedFunctionalInputVolume', formSubmitted()) as error">
        {{ error }}
      </desy-error-message>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Cumplimiento de reglamento IA</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col flex-1">
          <span>Papel de la administración respecto al sistema de IA*</span>
          <desy-select
            formControlName="administrationRole"
            classes="min-w-full mt-2">
            <desy-option
              [value]="5"
              [selected]="true"
              [hidden]="true"></desy-option>
            <desy-option
              *ngFor="let item of administrationRoleOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'administrationRole', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1">
          <span>Tipo de datos *</span>
          <desy-select
            formControlName="dataType"
            classes="min-w-full mt-2">
            <desy-option
              [disabled]="true"
              [hidden]="true"
              [selected]="true"
              value="">
              Selecciona el tipo de datos
            </desy-option>
            <desy-option
              *ngFor="let item of dataTypeOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'dataType', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
        <div
          class="flex flex-col flex-1"
          *ngIf="isOtherDataTypeSelected">
          <span>Otro tipo de datos*</span>
          <desy-input
            [formControl]="otherDataTypeControl"
            placeholder="Especifica el tipo de datos"
            [classes]="'w-full mt-2'"></desy-input>
          <desy-error-message *ngIf="getError(form, 'otherDataType', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1">
          <span>Nivel de explicabilidad del modelo*</span>
          <desy-select
            formControlName="explainabilityLevel"
            classes="min-w-full mt-2">
            <desy-option
              [disabled]="true"
              [hidden]="true"
              [selected]="true"
              value="">
              Selecciona el nivel de explicabilidad
            </desy-option>
            <desy-option
              *ngFor="let item of explainabilityLevelOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'explainabilityLevel', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Datos económicos</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col flex-1">
          <span>Importe contratación (€) *</span>
          <desy-input
            [type]="'number'"
            id="contractingImport"
            [classes]="'w-full'"
            formControlName="contractingImport"></desy-input>
          <desy-error-message *ngIf="getError(form, 'contractingImport', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1">
          <span>Vigencia contratación (en meses)*</span>
          <desy-input
            [type]="'number'"
            id="contractValidity"
            [classes]="'w-full'"
            formControlName="contractValidity"></desy-input>
          <desy-error-message *ngIf="getError(form, 'contractValidity', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col flex-1">
          <span>Importe anual del sistema (€)*</span>
          <desy-input
            [type]="'number'"
            id="annualAmount"
            [classes]="'w-full'"
            formControlName="annualAmount"></desy-input>
          <desy-error-message *ngIf="getError(form, 'annualAmount', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1">
          <span>Ahorro anual estimado del sistema (€)*</span>
          <desy-input
            [type]="'number'"
            id="estimatedAnnualSavings"
            [classes]="'w-full'"
            formControlName="estimatedAnnualSavings"></desy-input>
          <desy-error-message *ngIf="getError(form, 'estimatedAnnualSavings', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-[16px]">Finalización vigencia contratación*</label>
          <app-date-picker
            [inline]="false"
            class="w-full flex-1"
            [placeholder]="'Seleccione una fecha'"
            [minDate]="minSelectableDate"
            formControlName="contractValidityDate" />
          <desy-error-message *ngIf="getError(form, 'contractValidityDate', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Gestión del riesgo</span>
      <div class="flex gap-3">
        <div class="flex flex-col flex-1">
          <label class="text-[16px]">Clasificacion del sistema*</label>
          <desy-select
            formControlName="systemClassification"
            classes="w-[50%] mt-2">
            <desy-label>Seleccione clasificación del sistema</desy-label>
            <desy-option
              [disabled]="true"
              [hidden]="true"
              [selected]="true"
              value="">
              Selecciona la clasificación
            </desy-option>
            <desy-option
              *ngFor="let item of systemClassificationOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'systemClassification', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>
  </div>
</form>
<p-confirmdialog />
